import trackedPageFactory from './trackedPageFactory';

export default data => PageToBeWrapped => trackedPageFactory(PageToBeWrapped, data);
